import { cn } from '~/utils/cnTailwind';

type Props = {
    className?: string;
};

// user with a right arrow from the C-POOL Figma library – Lucide has no equivalent
export const UserArrowIcon: React.FC<Props> = ({ className }) => (
    <svg
        aria-hidden
        className={cn('size-[15px] shrink-0', className)}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.33}
        viewBox="0 0 15 15"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M1.25 13.125C1.24997 12.2054 1.50357 11.3036 1.98289 10.5188C2.46222 9.73393 3.1487 9.0965 3.96685 8.67658C4.78499 8.25665 5.7031 8.0705 6.62019 8.13858C7.53729 8.20667 8.41784 8.52636 9.165 9.0625" />
        <path d="M11.875 10L13.75 11.875" />
        <path d="M10 11.875H13.75L11.875 13.75" />
        <path d="M9.375 5C9.375 6.72589 7.97589 8.125 6.25 8.125C4.52411 8.125 3.125 6.72589 3.125 5C3.125 3.27411 4.52411 1.875 6.25 1.875C7.97589 1.875 9.375 3.27411 9.375 5Z" />
    </svg>
);
